// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_k8L","col":"styles_col__1Uzag"};